import React from 'react';

const style = {
  borderTop: '8px solid black',
};

const HeaderOne = () => (
  <section className="bg-image2">
    <div className="container pt-4">
      <div className="row">
        <div
          data-wow-delay="1s"
          className="col-xl-7 col-lg-8 col-md-9 bg-white p-4 wow fadeInUp mirkoOne flip-vertical-right"
          style={style}
        >
          <div className="p-4">
            <h1>
              <a href="/products" className="link">
                Welcome to BusinessDNA!
              </a>
            </h1>
            <h6 className="wow fadeIn text-uppercase small text-bold wide-space">
              World of modern Business Internet Applications...
            </h6>
            <p className="lead pt-2 pr-2">
              BusinessDNA has a complete suite of products for organizations looking to simplify web publishing,
              e-commerce and newsletter management needs.
            </p>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-3" />
      </div>
    </div>
  </section>
);
export default HeaderOne;



// WEBPACK FOOTER //
// ./src/components/HeaderOne.js